import React from "react";
import { useNavigate } from "react-router-dom";

function EducationTypePage() {

  const navigate = useNavigate();


  // =====================================================
  // EDUCATION TYPES
  // =====================================================

  const educationTypes = [

    {
      id: 1,
      title: "Government",
      subtitle: "Government Schools",
      description:
        "Find government schools, teachers and learning resources.",
      icon: "🏫",
      className: "government-card",
    },

    {
      id: 2,
      title: "Private",
      subtitle: "Private Schools",
      description:
        "Explore private schools, teachers and educational programs.",
      icon: "🎓",
      className: "private-card",
    },

    {
      id: 3,
      title: "Tuition",
      subtitle: "Tuition Classes",
      description:
        "Discover tuition classes, teachers and subject-based lessons.",
      icon: "📚",
      className: "tuition-card",
    },

  ];


  // =====================================================
  // CARD CLICK
  // =====================================================

  const handleCardClick = (type) => {

    if (type === "Government") {

      navigate("/teacher-demo");

      return;

    }


    if (type === "Private") {

      navigate("/private");

      return;

    }


    if (type === "Tuition") {

      navigate("/tuition");

      return;

    }

  };


  return (

    <div className="education-type-page">


      {/* =================================================
          BACKGROUND
      ================================================= */}

      <div className="education-background">

        <div className="education-glow education-glow-one"></div>

        <div className="education-glow education-glow-two"></div>

        <div className="education-glow education-glow-three"></div>

      </div>


      {/* =================================================
          CONTENT
      ================================================= */}

      <div className="education-content">


        {/* =================================================
            HEADING
        ================================================= */}

        <div className="education-heading">

          <div className="education-small-title">
            EDUNET
          </div>

          <h1>
            Choose Your Education
          </h1>

          <p>
            Select an education type to continue
          </p>

        </div>


        {/* =================================================
            CARDS
        ================================================= */}

        <div className="education-cards">

          {educationTypes.map((item) => (

            <button
              key={item.id}
              type="button"
              className={`education-card ${item.className}`}
              onClick={() =>
                handleCardClick(item.title)
              }
            >


              {/* CARD ICON */}

              <div className="education-card-icon">

                {item.icon}

              </div>


              {/* CARD CONTENT */}

              <div className="education-card-content">

                <h2>
                  {item.title}
                </h2>

                <h4>
                  {item.subtitle}
                </h4>

                <p>
                  {item.description}
                </p>

              </div>


              {/* CARD ARROW */}

              <div className="education-card-arrow">

                →

              </div>


            </button>

          ))}

        </div>

      </div>


      <style>{`

        /* =====================================================
           GLOBAL
        ===================================================== */

        * {

          box-sizing:
            border-box;

        }


        /* =====================================================
           MAIN PAGE
        ===================================================== */

        .education-type-page {

          position: relative;

          width: 100%;

          min-height: 100vh;

          overflow: hidden;

          display: flex;

          align-items: center;

          justify-content: center;

          background:

            radial-gradient(
              circle at 50% 35%,
              rgba(
                76,
                82,
                180,
                0.30
              ),
              transparent 38%
            ),

            linear-gradient(
              135deg,
              #080b20 0%,
              #111735 45%,
              #171029 100%
            );

          color: #fff;

          font-family:
            Arial,
            Helvetica,
            sans-serif;


          /* ===============================================
             NETFLIX STYLE PAGE REVEAL
          =============================================== */

          opacity: 0;

          transform:
            scale(1.035);

          animation:
            educationReveal
            0.9s
            cubic-bezier(
              0.22,
              0.61,
              0.36,
              1
            )
            forwards;

        }


        /* =====================================================
           PAGE REVEAL
        ===================================================== */

        @keyframes educationReveal {

          0% {

            opacity: 0;

            transform:
              scale(1.035);

          }


          35% {

            opacity: 0.30;

            transform:
              scale(1.022);

          }


          65% {

            opacity: 0.78;

            transform:
              scale(1.008);

          }


          100% {

            opacity: 1;

            transform:
              scale(1);

          }

        }


        /* =====================================================
           BACKGROUND
        ===================================================== */

        .education-background {

          position: absolute;

          inset: 0;

          overflow: hidden;

          pointer-events: none;

        }


        /* =====================================================
           BACKGROUND OVERLAY
        ===================================================== */

        .education-background::before {

          content: "";

          position: absolute;

          inset: 0;

          background:

            linear-gradient(
              rgba(
                5,
                8,
                25,
                0.55
              ),
              rgba(
                5,
                8,
                25,
                0.82
              )
            );

          z-index: 1;

        }


        /* =====================================================
           GLOWS
        ===================================================== */

        .education-glow {

          position: absolute;

          border-radius: 50%;

          filter:
            blur(80px);

          opacity:
            0.35;

        }


        .education-glow-one {

          width: 380px;

          height: 380px;

          top: -120px;

          left: -100px;

          background:
            #3549d8;

        }


        .education-glow-two {

          width: 420px;

          height: 420px;

          right: -150px;

          bottom: -130px;

          background:
            #8b36c7;

        }


        .education-glow-three {

          width: 250px;

          height: 250px;

          left: 50%;

          top: 50%;

          transform:
            translate(
              -50%,
              -50%
            );

          background:
            #4058e8;

          opacity:
            0.12;

        }


        /* =====================================================
           CONTENT
        ===================================================== */

        .education-content {

          position: relative;

          z-index: 5;

          width: 100%;

          max-width: 1250px;

          padding:
            50px 30px;

        }


        /* =====================================================
           HEADING
        ===================================================== */

        .education-heading {

          text-align:
            center;

          margin-bottom:
            42px;

        }


        .education-small-title {

          margin-bottom:
            10px;

          font-size:
            14px;

          font-weight:
            700;

          letter-spacing:
            4px;

          color:
            #9daaff;

        }


        .education-heading h1 {

          margin:
            0;

          font-size:
            42px;

          line-height:
            1.15;

          font-weight:
            800;

          letter-spacing:
            -1px;

          color:
            #ffffff;

        }


        .education-heading p {

          margin:
            13px 0 0;

          font-size:
            17px;

          color:
            rgba(
              255,
              255,
              255,
              0.68
            );

        }


        /* =====================================================
           CARDS
        ===================================================== */

        .education-cards {

          display:
            grid;

          grid-template-columns:
            repeat(
              3,
              1fr
            );

          gap:
            24px;

          width:
            100%;

        }


        /* =====================================================
           CARD
        ===================================================== */

        .education-card {

          position:
            relative;

          min-height:
            330px;

          padding:
            34px 30px;

          border:
            1px solid
            rgba(
              255,
              255,
              255,
              0.12
            );

          border-radius:
            20px;

          overflow:
            hidden;

          text-align:
            left;

          color:
            #fff;

          cursor:
            pointer;

          background:
            rgba(
              255,
              255,
              255,
              0.075
            );

          backdrop-filter:
            blur(18px);

          -webkit-backdrop-filter:
            blur(18px);

          box-shadow:
            0 20px 60px
            rgba(
              0,
              0,
              0,
              0.35
            );

          transition:
            transform .3s ease,
            box-shadow .3s ease,
            border-color .3s ease,
            background .3s ease;

        }


        /* =====================================================
           CARD GLOW
        ===================================================== */

        .education-card::before {

          content:
            "";

          position:
            absolute;

          width:
            180px;

          height:
            180px;

          top:
            -80px;

          right:
            -60px;

          border-radius:
            50%;

          background:
            rgba(
              255,
              255,
              255,
              0.08
            );

          transition:
            transform .4s ease;

        }


        /* =====================================================
           CARD BOTTOM LINE
        ===================================================== */

        .education-card::after {

          content:
            "";

          position:
            absolute;

          left:
            0;

          right:
            0;

          bottom:
            0;

          height:
            4px;

          opacity:
            0.85;

        }


        .government-card::after {

          background:

            linear-gradient(
              90deg,
              #2d63ff,
              #5f8cff
            );

        }


        .private-card::after {

          background:

            linear-gradient(
              90deg,
              #8b3dff,
              #c46cff
            );

        }


        .tuition-card::after {

          background:

            linear-gradient(
              90deg,
              #e69a28,
              #ffd05a
            );

        }


        /* =====================================================
           CARD HOVER
        ===================================================== */

        .education-card:hover {

          transform:
            translateY(-10px);

          background:
            rgba(
              255,
              255,
              255,
              0.11
            );

          border-color:
            rgba(
              255,
              255,
              255,
              0.27
            );

          box-shadow:
            0 28px 70px
            rgba(
              0,
              0,
              0,
              0.48
            );

        }


        .education-card:hover::before {

          transform:
            scale(1.45);

        }


        /* =====================================================
           CARD ICON
        ===================================================== */

        .education-card-icon {

          position:
            relative;

          z-index:
            2;

          width:
            68px;

          height:
            68px;

          display:
            flex;

          align-items:
            center;

          justify-content:
            center;

          margin-bottom:
            28px;

          border-radius:
            18px;

          background:
            rgba(
              255,
              255,
              255,
              0.10
            );

          border:
            1px solid
            rgba(
              255,
              255,
              255,
              0.14
            );

          font-size:
            31px;

          box-shadow:
            0 10px 25px
            rgba(
              0,
              0,
              0,
              0.18
            );

        }


        /* =====================================================
           CARD CONTENT
        ===================================================== */

        .education-card-content {

          position:
            relative;

          z-index:
            2;

        }


        .education-card h2 {

          margin:
            0 0 7px;

          font-size:
            27px;

          font-weight:
            750;

          color:
            #fff;

        }


        .education-card h4 {

          margin:
            0 0 14px;

          font-size:
            14px;

          font-weight:
            500;

          color:
            rgba(
              255,
              255,
              255,
              0.65
            );

        }


        .education-card p {

          margin:
            0;

          max-width:
            280px;

          font-size:
            14px;

          line-height:
            1.65;

          color:
            rgba(
              255,
              255,
              255,
              0.70
            );

        }


        /* =====================================================
           ARROW
        ===================================================== */

        .education-card-arrow {

          position:
            absolute;

          z-index:
            3;

          right:
            25px;

          bottom:
            22px;

          width:
            40px;

          height:
            40px;

          display:
            flex;

          align-items:
            center;

          justify-content:
            center;

          border-radius:
            50%;

          background:
            rgba(
              255,
              255,
              255,
              0.10
            );

          color:
            #fff;

          font-size:
            21px;

          transition:
            transform .3s ease,
            background .3s ease;

        }


        .education-card:hover
        .education-card-arrow {

          transform:
            translateX(5px);

          background:
            rgba(
              255,
              255,
              255,
              0.18
            );

        }


        /* =====================================================
           TABLET
        ===================================================== */

        @media (max-width: 900px) {

          .education-content {

            max-width:
              720px;

          }


          .education-cards {

            grid-template-columns:
              1fr;

          }


          .education-card {

            min-height:
              240px;

          }

        }


        /* =====================================================
           MOBILE
        ===================================================== */

        @media (max-width: 600px) {

          .education-content {

            padding:
              35px 18px;

          }


          .education-heading {

            margin-bottom:
              28px;

          }


          .education-heading h1 {

            font-size:
              30px;

          }


          .education-heading p {

            font-size:
              14px;

          }


          .education-cards {

            gap:
              15px;

          }


          .education-card {

            min-height:
              215px;

            padding:
              25px 22px;

            border-radius:
              16px;

          }


          .education-card-icon {

            width:
              55px;

            height:
              55px;

            margin-bottom:
              18px;

            border-radius:
              14px;

            font-size:
              25px;

          }


          .education-card h2 {

            font-size:
              23px;

          }


          .education-card p {

            font-size:
              13px;

          }

        }


        /* =====================================================
           REDUCED MOTION
        ===================================================== */

        @media (prefers-reduced-motion: reduce) {

          .education-type-page {

            animation:
              none;

            opacity:
              1;

            transform:
              none;

          }

        }

      `}</style>

    </div>
  );
}

export default EducationTypePage;